export default __webpack_public_path__ + "static/media/tickwithlowbg.e5e8f0b3.svg";